import styled from 'styled-components';
import { media, layout } from 'src/components/base';

export const ArticleWrapper = styled.section`
  margin-bottom: ${layout.margins.component.desktop.rem};

  ${media.mediumDown`
    margin-bottom: ${layout.margins.component.mobile.rem}
  `};
`;
export const Wrapper = styled.section`
  max-width: 71.42857rem;
  margin-right: auto;
  margin-left: auto;
  display: flex;
  flex-flow: row wrap;
  padding-left: ${layout.margins.wrapper.desktop.rem};
  padding-right: ${layout.margins.wrapper.desktop.rem};
  margin-top: 0;

  ${media.mediumDown`
    padding-left: ${layout.margins.wrapper.mobile.rem};
    padding-right: ${layout.margins.wrapper.mobile.rem};
  `};
`;

export const BreadCrumbWrapper = styled.div`
  margin: ${layout.measurements.spacing050} ${layout.measurements.spacing050}
    ${layout.measurements.spacing050} 0;
`;
